module.exports = __webpack_public_path__ + "static/img/bg-pic.f543e40.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/With/bg-pic.png
// module id = x3to
// module chunks = 0